import { gql } from '@apollo/client';
import { ROUTE_PATTERN_ROBOTS_TXT, BLAZE_STATIC_ROUTE_STORE_KEY } from '../../constants';
import getHandler from './generic-file-handler';

const storeKey = process.env.BLAZE_STATIC_ROUTE_STORE_KEY || BLAZE_STATIC_ROUTE_STORE_KEY;

export const fileQuery = gql`
  query {
    files: getFiles(
      where: { storeKey: "${storeKey}", filename: "robots.txt" }
      limit: 1
      sort: [{ property: "created", direction: "desc" }]
    ) {
      mimetype
      url
    }
  }
`;

export const pattern = new RegExp(ROUTE_PATTERN_ROBOTS_TXT);

export const handler = getHandler(fileQuery);
